import ApproverTabs from './ApproverTabs'
import ApproverResources from './ListPages/ApproverResources'
import { useProfileDisplay } from '../../hooks/useProfileDisplay'

const ApproverContainer = () => {
  const { userInfo, primaryApproverInfo, userNuid } = useProfileDisplay()
  return (
    <div className='page-container min-h-[70vh] lg:mx-40! desktop:mx-[120px]! tablet:mx-5! mobile:mx-4!'>
      <div className="padding-bottom-2u margin-top-4u desktop:mt-[60px]! tablet:mt-[50px]! mobile:mt-3.5!">
        <h1 className="h1">Manage Time Off Requests</h1>
        <p className="p3 -book mb-0!">You are logged in as:</p>
        <h3 className='h3 mb-0! mt-0!'>{userInfo} {userNuid}</h3>
        <p className='p3 -book mt-0! desktop:mb-2!'>Primary Approver: {primaryApproverInfo}</p>
      </div>
      <ApproverTabs />
      <ApproverResources />
    </div>
  )
}

export default ApproverContainer
